module.exports = __webpack_public_path__ + "img/5.d8a6cdb2.png";